import { Injectable } from '@angular/core';

import { Model } from '../shared/model'

@Injectable()
export class User extends Model {

  // properties
  id                  : number | null
  email               : string
  firstName           : string
  lastName            : string
  gl_ip               : string
  is_admin            : string
  username            : string
  password            : string

  constructor(obj: User) {
    super(obj);
    Object.assign(this, obj);
  }
}
